import { render, staticRenderFns } from "./WidgetTemp.vue?vue&type=template&id=621b1d8f&"
import script from "./WidgetTemp.vue?vue&type=script&lang=js&"
export * from "./WidgetTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../boss_taobao/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports